import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { AutoComplete, Form, Input, Tooltip } from 'antd';
import {
  ButtonWrap,
  ContentWrapper,
  ForgetRuleContentWrap,
  LinkSystemWrap,
  PLusSymbol,
  RuleWrap,
  Wrap,
} from 'pages/settings_page/style';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { AntToggleButton } from 'component/form_component/style';
import {
  getDomainSettingPageDetails,
  getDomainSettingPageDetailsforloginUser,
  updateDomainSettings,
} from 'redux/slices/settingsSlice';
import { ReactComponent as InfoIcon } from 'assets/images/SVG/icons/info-icon.svg';
import { StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { ReactComponent as QuestionMark } from 'assets/images/SVG/icons/question_mark-icon.svg';
import ReturnSourceInfo from 'pages/settings_page/return_source_info';
import { getBrandings } from 'redux/slices/brandingSlice';
import { EMAIL_BASE_URL } from 'utils/url';

export default function SpecificDomainSettings({ ...record }) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [apiLoading, setApiLoading] = useState(false);
  const { domainSettingsData, domainSettingsDataloading } = useSelector((state) => state.settings);
  const [returntoSourceInfo, setReturntoSourceInfo] = useState(false);
  const { data } = useSelector((state) => state.brandings);
  const [viewProperties, setViewProperties] = useState({
    passwordAlphabets: false,
    passwordNumbers: false,
  });

  const initialValues = {
    changePassword: domainSettingsData?.changePassword || true,
    useUpnAsEmail: domainSettingsData?.useUpnAsEmail || false,
    emailBaseUrl: domainSettingsData?.emailBaseUrl || EMAIL_BASE_URL,
    userProfile: domainSettingsData?.userProfile || true,
    email: domainSettingsData?.email || true,
    userName: domainSettingsData?.userName || true,
    returnToSource: domainSettingsData?.returnToSource || false,
    mailUserCreation: domainSettingsData?.mailUserCreation || true,
    mailResetPassword: domainSettingsData?.mailResetPassword || true,
    mailUnlockUser: domainSettingsData?.mailUnlockUser || true,
    mailEnableUser: domainSettingsData?.mailEnableUser || true,
    mailDisableUser: domainSettingsData?.mailDisableUser || true,
    passwordGenerationLength: domainSettingsData?.passwordGenerationLength || 12,
    passwordGenerationAlphabets: domainSettingsData?.passwordGenerationAlphabets || true,
    passwordGenerationNumbers: domainSettingsData?.passwordGenerationNumbers || true,
    passwordGenerationSpecialCharacters: domainSettingsData?.passwordGenerationSpecialCharacters || true,
  };

  useEffect(() => {
    dispatch(getDomainSettingPageDetails(record.id));
    dispatch(getBrandings());
  }, []);

  // Set the initial values for the main form when Redux state changes
  useEffect(() => {
    if (domainSettingsData) {
      form.setFieldsValue({
        changePassword: domainSettingsData.changePassword,
        useUpnAsEmail: domainSettingsData.useUpnAsEmail,
        userProfile: domainSettingsData.userProfile,
        emailBaseUrl: domainSettingsData?.emailBaseUrl || EMAIL_BASE_URL,
        email: domainSettingsData.email,
        userName: domainSettingsData.userName,
        returnToSource: domainSettingsData?.returnToSource,
        mailUserCreation: domainSettingsData.mailUserCreation,
        mailResetPassword: domainSettingsData.mailResetPassword,
        mailUnlockUser: domainSettingsData.mailUnlockUser,
        mailEnableUser: domainSettingsData.mailEnableUser,
        mailDisableUser: domainSettingsData.mailDisableUser,
        passwordGenerationLength: domainSettingsData.passwordGenerationLength || 12,
        passwordGenerationAlphabets: domainSettingsData.passwordGenerationAlphabets,
        passwordGenerationNumbers: domainSettingsData.passwordGenerationNumbers,
        passwordGenerationSpecialCharacters: domainSettingsData.passwordGenerationSpecialCharacters,
      });
    } else {
      form.setFieldsValue(initialValues);
    }
  }, [domainSettingsData]);

  useEffect(() => {
    setViewProperties({
      ...viewProperties,
      passwordNumbers:
        domainSettingsData?.passwordGenerationNumbers && !domainSettingsData?.passwordGenerationAlphabets,
      passwordAlphabets:
        !domainSettingsData?.passwordGenerationNumbers && domainSettingsData?.passwordGenerationAlphabets,
    });
    setReturntoSourceInfo(domainSettingsData?.returnToSource);
  }, [domainSettingsData]);

  const CheckNumericOrAlpha = (fieldName, checked) => {
    const values = form.getFieldsValue();
    const updateViewProperties = (field, value) => setViewProperties({ ...viewProperties, [field]: value });

    if (fieldName === 'passwordGenerationAlphabets') {
      updateViewProperties('passwordNumbers', !checked && values.passwordGenerationNumbers);
    } else if (fieldName === 'passwordGenerationNumbers') {
      updateViewProperties('passwordAlphabets', !checked && values.passwordGenerationAlphabets);
    }
  };
  const handleReturntoSourceInfo = () => {
    const values = form.getFieldValue('returnToSource');
    setReturntoSourceInfo(values);
  };

  const onFinish = async (value) => {
    value.domainId = record.id;
    value.passwordGenerationLength = parseInt(value.passwordGenerationLength);
    value.emailBaseUrl = value.emailBaseUrl || EMAIL_BASE_URL;
    try {
      setApiLoading(true);
      const response = await dispatch(updateDomainSettings(value));
      if (response.payload && response.payload.status === 200) {
        await dispatch(getDomainSettingPageDetails(record.id));
        if (record.id === Number(localStorage.getItem('domainId'))) {
          await dispatch(getDomainSettingPageDetailsforloginUser(record.id));
        }
        await SweetSweetAlert({ sweetData: response.payload.data, icon: 'success', buttonColor: 'green' });
      } else {
        SweetSweetAlert({ text: response.payload.data, icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setApiLoading(false);
    }
  };
  return (
    <div>
      {apiLoading && <ModalOpenLoader />}
      {domainSettingsDataloading ? (
        <ModalOpenLoader />
      ) : (
        <Form
          className='af-superadmin-domain-setting-form-element'
          form={form}
          onFinish={onFinish}
          initialValues={initialValues}
          name='register'
          scrollToFirstError
        >
          <ContentWrapper className='af-superadmin-domain-setting-content-wrap'>
            <h3 className='af-superadmin-domain-setting-general-head'>General Options</h3>
            <Wrap className='wrapextend af-superadmin-domain-setting-general-wrap'>
              <Form.Item
                className='af-superadmin-domain-setting-general-form-item-change'
                label='Change Password'
                name='changePassword'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-domain-setting-general-change-toggle' />
              </Form.Item>

              <Form.Item
                className='af-superadmin-domain-setting-general-form-item-userself'
                label='User Profile Self Edit'
                name='userProfile'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-domain-setting-general-userself-toggle' />
              </Form.Item>
              <Form.Item
                className='af-superadmin-domain-setting-general-form-item-useEmail'
                label='Use UPN as Email'
                name='useUpnAsEmail'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-domain-setting-general-useEmail-toggle' />
              </Form.Item>
              <Form.Item
                className='af-superadmin-setting-general-form-item-emailBaseUrl'
                label='Email Base URL'
                name='emailBaseUrl'
                tooltip={{
                  title: `This URL will be replaced for {BASEURL} short code when sending emails to users.`,
                  trigger: 'click',
                  icon: <QuestionMark height={20} width={20} style={{ cursor: 'pointer' }} />,
                  overlayInnerStyle: {
                    backgroundColor: '#fff',
                    color: '#000',
                    border: '1px solid black',
                    width: '20em',
                  },
                }}
              >
                <AutoComplete
                  style={{
                    minWidth: '15em',
                  }}
                  className='af-superadmin-setting-general-autocomplete-emailBaseUrl'
                  options={data.map((option) => ({ value: `https://${option.url}` }))}
                />
              </Form.Item>
            </Wrap>
          </ContentWrapper>
          <ContentWrapper className='af-superadmin-domain-setting-content-second-wrap'>
            <h3 className='af-superadmin-domain-setting-forgot-rule-head'>Forgot Password Rule</h3>
            <Wrap className='af-superadmin-domain-setting-forgot-rule-wrap'>
              <ForgetRuleContentWrap className='af-superadmin-domain-setting-forgot-rule-content-wrap'>
                <div className='af-superadmin-domain-setting-forgot-rule-content-wrap'>
                  <p className='af-superadmin-domain-setting-forgot-rule-require'>
                    * Required fields for Forgot Password validation
                  </p>
                  <RuleWrap className='af-superadmin-domain-setting-forgot-rule-email-and-user'>
                    <Form.Item
                      className='af-superadmin-domain-setting-forgot-rule-form-item-user'
                      label='User Name'
                      name='userName'
                      valuePropName='checked'
                    >
                      <AntToggleButton
                        disabled
                        className='af-form-switch af-superadmin-domain-setting-forgot-rule-user-toggle'
                      />
                    </Form.Item>
                    <PLusSymbol className='af-form-switch af-superadmin-domain-setting-forgot-rule-plus'>+</PLusSymbol>
                    <Form.Item
                      className='af-superadmin-domain-setting-forgot-rule-form-item-email'
                      label='Email'
                      name='email'
                      valuePropName='checked'
                    >
                      <AntToggleButton className='af-form-switch af-superadmin-domain-setting-forgot-rule-email-toggle' />
                    </Form.Item>
                  </RuleWrap>
                </div>
                <div className='af-superadmin-domain-setting-forgot-rule-linksystem-wrap'>
                  <p className='af-superadmin-domain-setting-forgot-rule-linksystem'>
                    While linking from other systems
                  </p>
                  <LinkSystemWrap className='af-superadmin-domain-setting-forgot-rule-linksystem-button-wrap'>
                    <Form.Item
                      className='af-superadmin-domain-setting-forgot-rule-form-item-returnToSource'
                      label='Return to Source'
                      name='returnToSource'
                      valuePropName='checked'
                    >
                      <AntToggleButton
                        onChange={handleReturntoSourceInfo}
                        className='af-form-switch af-superadmin-domain-setting-forgot-rule-returnToSource-toggle'
                      />
                    </Form.Item>
                    {returntoSourceInfo && (
                      <Tooltip
                        title={<ReturnSourceInfo />}
                        placement='right'
                        color='#f9f9f9'
                        overlayStyle={{ maxWidth: 'min-content' }}
                        className='af-superadmin-domain-setting-forgot-rule-linksystem-icon-info-tooltip'
                      >
                        <InfoIcon className='af-superadmin-domain-setting-forgot-rule-linksystem-icon-info' />
                      </Tooltip>
                    )}
                  </LinkSystemWrap>
                </div>
              </ForgetRuleContentWrap>
            </Wrap>
          </ContentWrapper>
          <ContentWrapper className='af-superadmin-domain-setting-content-third-wrap'>
            <h3 className='af-superadmin-domain-setting-auto-rule-head'>Auto Password Rules</h3>
            <Wrap className='wrapextend af-superadmin-domain-setting-auto-rule-wrap'>
              <Form.Item
                label='Length'
                name='passwordGenerationLength'
                className='af-superadmin-domain-setting-auto-rule-form-item-length'
              >
                <Input
                  style={{
                    width: '70px',
                  }}
                  type='number'
                  min={8}
                  max={25}
                  className='af-superadmin-domain-setting-auto-rule-input-length'
                />
              </Form.Item>
              <Form.Item
                className='af-superadmin-domain-setting-auto-rule-form-item-alpha'
                label='Alphabets'
                name='passwordGenerationAlphabets'
                valuePropName='checked'
              >
                <AntToggleButton
                  className='af-form-switch af-superadmin-domain-setting-auto-rule-alpha-toggle'
                  disabled={viewProperties.passwordAlphabets}
                  onChange={(checked) => CheckNumericOrAlpha('passwordGenerationAlphabets', checked)}
                />
              </Form.Item>
              <Form.Item
                className='af-superadmin-domain-setting-auto-rule-form-item-number'
                label='Numbers:'
                name='passwordGenerationNumbers'
                valuePropName='checked'
              >
                <AntToggleButton
                  className='af-form-switch af-superadmin-domain-setting-auto-rule-number-toggle'
                  disabled={viewProperties.passwordNumbers}
                  onChange={(checked) => CheckNumericOrAlpha('passwordGenerationNumbers', checked)}
                />
              </Form.Item>
              <Form.Item
                className='af-superadmin-domain-setting-auto-rule-form-item-char'
                label='Special Characters'
                name='passwordGenerationSpecialCharacters'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-domain-setting-auto-rule-char-toggle' />
              </Form.Item>
            </Wrap>
          </ContentWrapper>
          <ContentWrapper className='af-superadmin-domain-setting-content-fourth-wrap'>
            <h3 className='af-superadmin-domain-setting-notify-head'>Email Notifications Defaults</h3>
            <Wrap className='wrapextend af-superadmin-domain-setting-notify-wrap'>
              <Form.Item
                className='af-superadmin-domain-setting-notify-form-item-creatmail'
                label='User Creation'
                name='mailUserCreation'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-domain-setting-notify-creatmail-toggle' />
              </Form.Item>
              <Form.Item
                className='af-superadmin-domain-setting-notify-form-item-resetmail'
                label='Reset Password'
                name='mailResetPassword'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-domain-setting-notify-resetmail-toggle' />
              </Form.Item>
              <Form.Item
                className='af-superadmin-domain-setting-notify-form-item-unlockmail'
                label='UnLock User'
                name='mailUnlockUser'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-domain-setting-notify-unlockmail-toggle' />
              </Form.Item>
              <Form.Item
                className='af-superadmin-domain-setting-notify-form-item-enablemail'
                label='Enable User'
                name='mailEnableUser'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-domain-setting-notify-enablemail-toggle' />
              </Form.Item>
              <Form.Item
                className='af-superadmin-domain-setting-notify-form-item-disablemail'
                label='Disable User'
                name='mailDisableUser'
                valuePropName='checked'
              >
                <AntToggleButton className='af-form-switch af-superadmin-domain-setting-notify-disablemail-toggle' />
              </Form.Item>
            </Wrap>
          </ContentWrapper>

          <ButtonWrap className='af-superadmin-domain-setting-button-wrap'>
            <StyledButton className='af-superadmin-domain-setting-button' type='primary' htmlType='submit'>
              Submit
            </StyledButton>
          </ButtonWrap>
        </Form>
      )}
    </div>
  );
}
